const cookieBanner = document.querySelector(".js-cookie-banner");

window.addEventListener("load", () => {
    const cookie = window.localStorage.getItem("cookieAccepted");
    if (!cookie) {
        cookieBanner.classList.add("m-cookie-banner--open");
    }
});

const acceptCookie = document.querySelector(".js-accept-cookies");

if (acceptCookie) {
    acceptCookie.addEventListener("click", (e) => {
        window.localStorage.setItem("cookieAccepted", true)
        cookieBanner.classList.remove("m-cookie-banner--open");
    });
}